import api from "./baseRequest";

export const menuSubcategoriesService = {
  getSubcategoryById: (id) => {
    return api.get(`/menu/subcategories/${id}`);
  },

  createSubcategory: ({ name, categoryId }) => {
    return api.post("/menu/subcategories", { name, categoryId });
  },

  updateSubcategory: (id, { name, categoryId }) => {
    return api.put(`/menu/subcategories/${id}`, { name, categoryId });
  },

  deleteSubcategory: (id) => {
    return api.delete(`/menu/subcategories/${id}`);
  },

  reorderSubcategories: ({ categoryId, subcategoryIds }) => {
    return api.patch("/menu/subcategories/reorder", {
      categoryId,
      subcategoryIds,
    });
  },
};
